import http from "@/services/http";

/**
 * Lista as avaliações de consumo de álcool de um paciente
 * (tabela patient_alcohol_assessments), mais recente primeiro.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getAlcoholByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-alcohol-assessments/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Cria uma avaliação de consumo de álcool (salvia-759).
 * @param {number|string} patientId
 * @param {object} payload { frequency?, assessed_at?, notes? }
 */
export function createAlcohol(patientId, payload) {
  return http.post("/api/patient-alcohol-assessments/create", {
    patient_id: patientId,
    ...payload,
  });
}

/**
 * Atualiza uma avaliação de consumo de álcool existente.
 */
export function updateAlcohol(id, payload) {
  return http.put(`/api/patient-alcohol-assessments/update/${id}`, payload);
}

/**
 * Remove uma avaliação de consumo de álcool (soft delete).
 */
export function deleteAlcohol(id) {
  return http.delete(`/api/patient-alcohol-assessments/delete/${id}`);
}
